"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropListItemTitle = void 0;
var React = require("react");
var DropList_styles_1 = require("./DropList.styles");
var DropListItemTitle = function (_a) {
    var Caption = _a.Caption;
    return (React.createElement(DropList_styles_1.DropListItemTitleWrapper, { onClick: function (e) { return e.stopPropagation(); } },
        React.createElement(DropList_styles_1.Header, null, Caption)));
};
exports.DropListItemTitle = DropListItemTitle;
